import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/partners/:id
//
// redirect: caller navigates to /admin/partners after success. Legacy
// action called Next's redirect(); the worker just returns { ok: true }.
export function useDeletePartner() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, string>({
    mutationFn: (id) =>
      apiFetch<{ ok: true }>(`/partners/${id}`, { method: "DELETE" }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.list() });
      // Phase 7 sub-bucket 10 — admin list + dashboard ripple. Deleting an
      // active partner shrinks `metrics.activePartners`; also clears the
      // row from the admin partners table and the dashboard leaderboard.
      queryClient.invalidateQueries({ queryKey: queryKeys.admin.partners.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.admin.dashboard() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete partner");
    },
  });
}
